// NEW_FILE_JUSTIFIED: Contact card for provider form — no existing component handles multi-field contact editing
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Trash2 } from 'lucide-react';
import type { IProviderContactCardProps } from '@/@types/insurance';

export function ProviderContactCard({
  index,
  contact,
  onUpdate,
  onRemove,
  disabled,
}: IProviderContactCardProps) {
  return (
    <div className="bg-muted/50 border border-border rounded-lg p-4 flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-foreground">Contact {index + 1}</span>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          onClick={() => onRemove(index)}
          disabled={disabled}
          className="h-7 w-7 text-muted-foreground hover:text-destructive"
        >
          <Trash2 className="w-4 h-4" />
        </Button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div className="flex flex-col gap-1">
          <label className="text-xs font-medium text-muted-foreground">Name</label>
          <Input
            value={contact.name}
            onChange={e => onUpdate(index, 'name', e.target.value)}
            placeholder="Contact name"
            disabled={disabled}
          />
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-xs font-medium text-muted-foreground">
            Phone (with country code)
          </label>
          <Input
            type="tel"
            value={contact.phone}
            onChange={e => onUpdate(index, 'phone', e.target.value)}
            placeholder="+1 234 567 8900"
            disabled={disabled}
          />
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-xs font-medium text-muted-foreground">Email</label>
          <Input
            type="email"
            value={contact.email ?? ''}
            onChange={e => onUpdate(index, 'email', e.target.value)}
            placeholder="email@example.com"
            disabled={disabled}
          />
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-xs font-medium text-muted-foreground">WhatsApp</label>
          <Input
            type="tel"
            value={contact.whatsapp ?? ''}
            onChange={e => onUpdate(index, 'whatsapp', e.target.value)}
            placeholder="+1 234 567 8900"
            disabled={disabled}
          />
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-xs font-medium text-muted-foreground">Telegram</label>
          <Input
            value={contact.telegram ?? ''}
            onChange={e => onUpdate(index, 'telegram', e.target.value)}
            placeholder="@username or phone"
            disabled={disabled}
          />
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-xs font-medium text-muted-foreground">Viber</label>
          <Input
            type="tel"
            value={contact.viber ?? ''}
            onChange={e => onUpdate(index, 'viber', e.target.value)}
            placeholder="+1 234 567 8900"
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
}
